const SelectOption = (props) => {
    const data = props.data;
    return (
        <>
            <option value="">Please select</option>
            {
                data.map((val) => {
                    return <option key={val.code}
                        value={val.code}>{val.description}</option>
                })
            }
        </>
    )
}
export default SelectOption;